import { useContext, useEffect, useState } from 'react';
import {
  CORE_SORT_OPTIONS,
  MASTER_SORT_OPTIONS,
} from 'utils/constants/MasterSort';
import { FilterContext } from 'utils/context';
import DK from 'utils/dictionaries/filter_dictionary';

import {
  Box,
  Select,
  SelectProps,
  StyledSystem,
} from '@project44/manifest-ui-deprecated';
import { useTranslation } from '@project44/translations-utils';

export interface IMasterSort {
  doSearch: () => void;
  sx?: StyledSystem.SystemStyleObject;
}

type TOption = {
  columnLabel?: string;
  label: string;
  value: string;
};

type TOptions = Array<TOption>;

function MasterSort({ doSearch, sx }: IMasterSort) {
  const { t } = useTranslation();
  const { filters, setFiltersKey } = useContext(FilterContext);

  const findOption = (opts: TOptions) => {
    const [sortBy, direction] = filters[DK.SORT_BY] || [];
    const match = `${sortBy}/${direction}`;
    const opt = MASTER_SORT_OPTIONS.find(({ value }) => value === match);
    return opt || opts.find(({ value }) => value === 'recently_updated/desc');
  };

  const [options, setOptions] = useState(CORE_SORT_OPTIONS);
  const [selected, setSelected] = useState(findOption(options));

  const handleChange = (option: TOption) => {
    setSelected(option);
    setOptions(CORE_SORT_OPTIONS);
    setFiltersKey(DK.SORT_BY, option.value.split('/'));
    doSearch();
  };

  useEffect(() => {
    const option = findOption(MASTER_SORT_OPTIONS);
    if (option && option !== selected) {
      setSelected(option);
      if (!options.some((opt) => opt === option)) {
        setOptions([option, ...CORE_SORT_OPTIONS]);
      }
    }
  }, [filters[DK.SORT_BY]]);

  return (
    <Box
      sx={{
        bgColor: 'white',
        fontWeight: 'bold',
        width: '275px',
        '.manifestui-select__control': {
          height: '32px',
          borderColor: '#E4E6E7',
        },
        '.manifestui-select__option': {
          height: '32px',
          fontSize: 'small',
        },
        ...sx,
      }}
    >
      <Select
        startIcon={<div>{t('core.sortByLabel')}</div>}
        onChange={handleChange as SelectProps['onChange']}
        options={options}
        placeholder=""
        value={
          !!selected && {
            label: selected.columnLabel || selected.label,
            value: selected.value,
          }
        }
      />
    </Box>
  );
}

export default MasterSort;
